import type { AutoPopulateData, OrderPdfData } from './pdfTypes'

type PatientSelectedLocationFields = Pick<
  OrderPdfData,
  'facilityHeader' | 'providerFaxLabel' | 'patientInstruction' | 'resultRouting'
>

/**
 * PD-1312 — the PDF overlay for a "patient will choose a location" lab order.
 *
 * No facility was selected and nothing was faxed, so the requisition has to
 * carry three things a facility-bound one gets for free: which lab honours it
 * (header, right), what the patient is supposed to do with the printout, and
 * where the lab should send results back to.
 *
 * Shared by the Labcorp and Quest mappers so the wording can't drift apart.
 */
export function buildPatientSelectedLocationPdfFields(
  labName: string,
  auto: AutoPopulateData,
): PatientSelectedLocationFields {
  const practiceName = auto.provider.organizationName || 'BeHuman Medical Group'
  const practiceFax = auto.provider.orgFax

  return {
    facilityHeader: {
      name: `${labName} — Patient-selected location`,
      subtitle: `Valid at any ${labName} location offering the ordered test`,
      // No branch address or fax to print — the whole point of this mode.
      address: '',
      fax: '',
    },
    providerFaxLabel: 'Results Fax',
    patientInstruction: `Patient: Bring this printed requisition, photo ID, and insurance card to your selected ${labName} location.`,
    resultRouting: practiceFax
      ? `Please fax all results to ${practiceName} at ${practiceFax}.`
      : `Please send all results to ${practiceName}.`,
  }
}
